/* eslint-disable object-curly-newline */
import { getRandomNumbers } from '@/utils/getRandomNumbers';
import { article } from './mock_init.constant.article';
import { article as iframeArticle } from './mock_init.constant.article.iframe';

export const tempCallback = {
  session_id: 1,
  dialogue_id: '1',
  input_type: 1,
  message_extra: {
    node_id: 12,
    params: {
      a: 1,
      b: 2,
    },
  },
  message_text: 'what happen when jump to google',
};

export function MSG(text?: any, data?: any, feedback?: any) {
  return {
    reply_type: 1,
    message: {
      message_id: getRandomNumbers(),
      text_key: '',
      text_value: text || 'Here are your orders. Which order would you like to track?',
      text_extra: null,
    },
    message_extra: {
      feedback_options: null,
      ...feedback,
    },
    ...data,
  };
}

export function ARTICLE(count: any = 1, data?: any) {
  const item = {
    id: 'ka06F000000FkPdQAK',
    title: '[Return Refund] What should I do if I want to apply for refund/return request?',
    url_name: 'What-should-I-do-if-I-want-to-apply-for-refund-return-request',
    content: article,
    article_number: '000009225',
  };
  return {
    reply_type: 2,
    message: '',
    message_extra: {
      articles: Array(count).fill(item),
      feedback_options: null,
    },
    ...data,
  };
}

export function IFRAME_ARTICLE(count: any = 1, data?: any) {
  const item = {
    id: 'ka06F000000FkPdQAK',
    title: 'Article with iframe',
    url_name: 'What-should-I-do-if-I-want-to-apply-for-refund-return-request',
    content: iframeArticle,
    article_number: '000009225',
  };
  return {
    reply_type: 2,
    message: '',
    message_extra: {
      articles: Array(count).fill(item),
      feedback_options: null,
    },
    ...data,
  };
}

export function OPTION() {
  return {
    reply_type: 3,
    message: {
      message_id: getRandomNumbers(),
      text_key: '',
      text_value: 'Show the different style of option',
    },
    message_extra: {
      buttons_for_taskbot: [
        {
          style: 1,
          text_key: '',
          text_value: 'Option 1',
          node_id: 1,
        },
        {
          style: 2,
          text_key: '',
          text_value: 'Option 2',
          node_id: 2,
        },
        {
          style: 3,
          text_key: '',
          text_value: 'Option 3',
          node_id: 3,
        },
        {
          style: 4,
          text_key: '',
          text_value: 'Option 4',
          node_id: 4,
        },
        {
          style: 5,
          text_key: '',
          text_value: 'Option 5',
          node_id: 5,
        },
        {
          style: 6,
          text_key: '',
          text_value: 'Option 6',
          node_id: 6,
        },
        {
          node_id: 'SOP_2_NODE_0_1',
          text_key: 'sop_2_node_0_1_btn_0',
          text_value: 'purchase',
        },
        {
          node_id: 'SOP_2_NODE_0_2',
          text_key: 'sop_2_node_0_2_btn_0',
          text_value: 'top up  ',
        },
        {
          node_id: 'SOP_2_NODE_0_3',
          text_key: 'sop_2_node_0_3_btn_0',
          text_value: 'withdraw',
        },
        {
          node_id: 'SOP_2_NODE_0_4',
          text_key: 'sop_2_node_0_4_btn_0',
          text_value: 'Reset Shopeepay PIN',
        },
      ],
    },
  };
}

export function FEEDBACK(feedbacks: (number | string)[]) {
  return {
    reply_type: 4,
    message: {
      message_id: getRandomNumbers(),
      text_key: 'msg_feedback',
      text_value: 'Was this answer helpful?',
    },
    message_extra: {
      buttons_for_feedback: feedbacks.map((feedback, index) => ({
        text_value: feedback,
        text_key: `btn_feedback_${index + 1}`,
      })),
      feedback_options: null,
      feedback_info: { style: 2 },
    },
  };
}

export function REDIRECTION(text_value = 'Redirect Button') {
  return {
    reply_type: 5,
    message: {
      message_id: getRandomNumbers(),
      text_key: '',
      text_value,
    },
    message_extra: {
      buttons_for_redirection: [
        {
          text_key: 'btn_feedback_1',
          text_value: 1,
          uri_key: 'order_cancel_by_system_form_page',
          url: '',
          uri_extra: {},
          extraParams: {},
        },
        {
          text_key: 'btn_feedback_2',
          text_value: 2,
          uri_key: '',
          url: 'shopee.com',
          uri_extra: {},
          extraParams: {},
        },
      ],
      feedback_options: null,
    },
  };
}

export function LIVE(
  text_value = 'call live agent',
  queues: {
    queue_name?: string;
    user_type?: number | string;
    enquiry_type?: number | string;
  }[],
) {
  return {
    reply_type: 6,
    message: {
      message_id: getRandomNumbers(),
      text_key: '',
      text_value,
    },
    message_extra: {
      buttons_for_live: queues.map((data) => ({
        text_key: 'btn_live',
        text_value: data.queue_name,
        queue_name: data.queue_name,
        user_type: data.user_type,
        enquiry_type: data.enquiry_type,
      })),
      feedback_options: null,
    },
  };
}

export function ORDER() {
  return {
    reply_type: 7,
    message: {
      message_id: getRandomNumbers(),
      text_key: '',
      text_value: '',
      text_extra: null,
    },
    message_extra: {
      order_info: {
        show_type: 1,
        node_id: 'SOP_1_NODE_0_1_1',
        has_more: true,
        is_seller: false,
        order_list: [
          {
            order_id: 57730473258785,
            order_sn: '201030N89SJQS1',
            shop_id: 175379978,
            checkout_id: 57730473205374,
            uri_key: 'order_detail_page',
            title: 'test 2019-12-12 22:51:34.130',
            image: 'ad29861369c78bad67edff573c31e5da',
            total_item_count: 12,
            total_item_price: 123,
            status: 'cancel',
            price: 1000,
            specification: 'test 2019-12-12 22:51:34.130',
          },
          {
            order_id: 57140687178137,
            order_sn: '201023430SQXCS',
            shop_id: 7437303,
            checkout_id: 57140687173726,
            uri_key: 'order_detail_page',
            title: 'MBPITEM5-25',
            image: 'a970be2adbf647574c3023e2e82e29ea',
            price: 100,
            specification: 'MBPITEM5-25',
          },
          {
            order_id: 53839726089314,
            order_sn: '200915RE1S6H32',
            shop_id: 363586,
            checkout_id: 53839726065106,
            uri_key: 'order_detail_page',
            title: 'hahahaha 2020-09-04 17:29:55.548',
            image: '2e3b2e7e663ecb22d7c6f60e0e8d8585',
            price: 1000,
            specification: '',
          },
          {
            order_id: 53839627014746,
            order_sn: '200915RDXTQ0JT',
            shop_id: 509247,
            checkout_id: 53839627061922,
            uri_key: 'order_detail_page',
            title: 'hahahaha 2020-09-04 17:29:55.548',
            image: 'eea1ec88ed92a78c74787d0bb205a5f1',
            price: 1000,
            specification: '',
          },
          {
            order_id: 53839590192383,
            order_sn: '200915RDWQK97Y',
            shop_id: 509247,
            checkout_id: 53839590100861,
            uri_key: 'order_detail_page',
            title: 'hahahaha 2020-09-04 17:29:55.548',
            image: '4a743c5a7439cbe9c9be179153098572',
            price: 1000,
            specification: '',
          },
        ],
      },
      feedback_options: null,
    },
  };
}

export function RR_REQUEST_INFO() {
  return {
    reply_type: 12,
    message: {
      message_id: getRandomNumbers(),
      text_key: '',
      text_value: '',
      text_extra: null,
    },
    message_extra: {
      rr_request_info: {
        node_id: 'SOP_4_NODE_0_1_1',
        has_more: true,
        is_seller: false,
        rr_request_list: [
          {
            return_id: 0,
            order_id: 57730473258785,
            order_sn: '201030N89SJQS1',
            shop_id: 175379978,
            checkout_id: 57730473205374,
            uri_key: 'order_detail_page',
            title: 'test 2019-12-12 22:51:34.130',
            image: 'ad29861369c78bad67edff573c31e5da',
            price: 1000,
            specification: 'test 2019-12-12 22:51:34.130',
          },
          {
            return_id: 0,
            order_id: 57140687178137,
            order_sn: '201023430SQXCS',
            shop_id: 7437303,
            checkout_id: 57140687173726,
            uri_key: 'order_detail_page',
            title: 'MBPITEM5-25',
            image: 'a970be2adbf647574c3023e2e82e29ea',
            price: 100,
            specification: 'MBPITEM5-25',
          },
          {
            return_id: 1041357,
            order_id: 53839726089314,
            order_sn: '',
            shop_id: 363586,
            checkout_id: 0,
            uri_key: 'buyer_order_return_page',
            title: 'hahahaha 2020-09-04 17:29:55.548',
            image: '2e3b2e7e663ecb22d7c6f60e0e8d8585',
            price: 1004,
            specification: '',
          },
          {
            return_id: 0,
            order_id: 53839627014746,
            order_sn: '200915RDXTQ0JT',
            shop_id: 509247,
            checkout_id: 53839627061922,
            uri_key: 'order_detail_page',
            title: 'hahahaha 2020-09-04 17:29:55.548',
            image: 'eea1ec88ed92a78c74787d0bb205a5f1',
            price: 1000,
            specification: '',
          },
          {
            return_id: 0,
            order_id: 53839590192383,
            order_sn: '200915RDWQK97Y',
            shop_id: 509247,
            checkout_id: 53839590100861,
            uri_key: 'order_detail_page',
            title: 'hahahaha 2020-09-04 17:29:55.548',
            image: '4a743c5a7439cbe9c9be179153098572',
            price: 1000,
            specification: '',
          },
        ],
      },
      feedback_options: null,
    },
  };
}

export function TRANSACTION(type: 1 | 2 = 1, has_more = true) {
  return {
    reply_type: 15,
    message: {
      message_id: getRandomNumbers(),
      text_key: '',
      text_value: 'Select the topup you want to enquire about:',
      text_extra: null,
    },
    message_extra: {
      transactions: {
        node_id: 'SOP_4_NODE_0_1_1',
        has_more,
        type, // 交易类型：1充值 2提现
        list: [
          {
            sn: '1', //	string	必须 序列号
            amount: '123456', //	string	必须 金额 string(int)
            bank_name: 'BNIBCA BNIBCABNIBCABNIBCA', //	string	必须 提现的银行(only 提现)
            payment_channel_text: 'Credit Card', //	string	必须 支付渠道文案(only 充值)
            create_time: 'test 2019-12-12 22:51:34.130', //	string	必须 创建时间
            status: 1,
          },
          {
            sn: '2', //	string	必须 序列号
            amount: '100000000000', //	string	必须 金额 string(int)
            bank_name: 'BNIBNI', //	string	必须 提现的银行(only 提现)
            payment_channel_text: 'Credit Card', //	string	必须 支付渠道文案(only 充值)
            create_time: 'test 2019-12-12 22:51:34.130', //	string	必须 创建时间
            status: 1,
          },
          {
            sn: '3', //	string	必须 序列号
            amount: '123456', //	string	必须 金额 string(int)
            bank_name: 'BNI', //	string	必须 提现的银行(only 提现)
            payment_channel_text: 'Credit Card', //	string	必须 支付渠道文案(only 充值)
            create_time: 'test 2019-12-12 22:51:34.130', //	string	必须 创建时间
            status: 1,
          },
          {
            sn: '4', //	string	必须 序列号
            amount: '123456', //	string	必须 金额 string(int)
            bank_name: 'BNI', //	string	必须 提现的银行(only 提现)
            payment_channel_text: 'Credit Card', //	string	必须 支付渠道文案(only 充值)
            create_time: 'test 2019-12-12 22:51:34.130', //	string	必须 创建时间
            status: 1,
          },
        ].slice(0, has_more ? 5 : 1),
      },
      buttons_for_general: [
        {
          button_type: 'btn_live',
          node_id: '',
          text_key: 'sop_2_node_0_2_1_btn_1',
          text_value: '',
          url: '',
          uri_key: '',
          queue_name: 'ID_Chat_Buyer_ShopeePay',
          uri_extra: null,
          article_number: '',
          order_extra: null,
          style: 0,
          callback: null,
        },
      ],
      feedback_options: null,
    },
  };
}
export function QA_BUTTON() {
  return {
    reply_type: 8,
    message: {
      message_id: getRandomNumbers(),
      text_key: '',
      text_value: 'call live agent 2',
    },
    message_extra: {
      buttons_for_qabot: [
        {
          text_key: '',
          text_value: 'live agent',
          title: 'QA Button',
          queue_name: 'abc',
          article_number: '123',
        },
      ],
      feedback_options: null,
    },
  };
}

export function GENERAL_BTN(text_value: string, buttons: any[]) {
  return {
    reply_type: 10,
    message: {
      message_id: getRandomNumbers(),
      text_key: '',
      text_value: 'Please click the button below to change your phone number',
    },
    message_extra: {
      buttons_for_general: [...buttons],
      feedback_options: null,
    },
  };
}

export function GENERAL_BTN_ITEM(data: any) {
  return {
    button_type: 'btn_redirection',
    node_id: '',
    text_key: '',
    text_value: 'Single Button',
    url: '',
    uri_key: '',
    queue_name: '',
    uri_extra: null,
    article_number: '',
    order_extra: null,
    style: 1,
    callback: null,
    ...data,
  };
}

export function GENERAL_BTN_MODAL_GUARANTEE({
  text_value,
  pop_up_content,
  article,
  yes_callback,
  no_callback,
}: {
  text_value?: string;
  pop_up_content?: any;
  article?: any;
  yes_callback?: any;
  no_callback?: any;
} = {}) {
  return GENERAL_BTN_ITEM({
    button_type: 'btn_modal',
    text_value,
    style: 6,
    isBtnDisabled: false,
    btn_modal_callback: {
      article: {
        contentid: 'ka06F000000FkPdQAK',
        title: '[Return Refund] What should I do if I want to apply for refund/return request?',
        url_name: 'What-should-I-do-if-I-want-to-apply-for-refund-return-request',
        content: article,
        article_number: '000009225',
        ...article,
      },
      yes_callback: {
        shouldDisappear: false,
        ...yes_callback,
      },
      no_callback,
      pop_up_content: {
        read_more: 'Read More',
        confirm_value: 'Yes',
        content: `You can extend Shopee Guarantee
         by 3 days to have more time to check your order after it's delivered. If you receive wrong. `,
        refuse_value: 'No',
        title: 'title 2',
        ...pop_up_content,
      },
    },
  });
}

export function DIRECTLY_REDIRECTION(url = 'https://google.com') {
  return {
    reply_type: 11,
    message: {
      message_id: getRandomNumbers(),
      text_key: 'msg_feedback',
      text_value: 'Was this answer helpful?',
    },
    message_extra: {
      text_key: '',
      text_value: 'https://google.com',
      url,
      uri_key: 'request_order_return_page',
      uri_extra: { order_id: 111123 },
    },
  };
}

export function BUTTON_FOR_TASKBOT_HORIZONTAL() {
  return {
    reply_type: 13,
    message: {
      message_id: getRandomNumbers(),
      text_key: 'sop_2_node_0_1_mgs_3',
      text_value: 'Did you forget ShopeePay PIN',
    },
    message_extra: {
      buttons_for_taskbot: [
        {
          node_id: 'SOP_2_NODE_0_1_1',
          text_key: 'sop_2_node_0_1_1_btn_0',
          text_value: 'Yes ',
          extra_param: { order_id: 123 },
        },
        {
          node_id: 'SOP_2_NODE_0_1_2',
          text_key: 'sop_2_node_0_1_2_btn_0',
          text_value: 'No',
          extra_param: { order_id: 123 },
        },
      ],
      feedback_options: null,
    },
  };
}

export function IntentHotQuestion() {
  return {
    reply_type: 21,
    message: {
      message_id: '429069263888083457',
      text_key: '',
      text_value: 'sha',
    },
    message_extra: {
      order: {
        'order_id': 1,
        'order_sn': '123',
        'shop_id': 123,
        'checkout_id': 123,
        'uri_key': 'xxx',
        'title': 'xxx',
        'image': 'xxx',
        'price': 123,
        'total_price': 123,
        'specification': 'xxx',
        'button_type': 'xxx',
        'button_id': '1',
        'tracing_number': '1',
        'delivered_by': '1',
        'return_items_count': 0,
        'refund_amount': 0,
        'return_status': 0,
        'return_status_desc': '',
        'order_status': 1,
        'order_status_desc': 'xxx',
        'order_status_ext': 1,
        'item_count': 1,
        'list_type': 1,
        'status': 'xx',
        'total_item_price': 1,
        'total_item_count': 1,
      },
      next_head_intents: [
        {
          intent_id: 443,
          intent_name: '',
          faq_name: '',
          category_name: '',
          intent_type: 0,
          category_id: 0,
          icon_url: '',
          page_num: 0,
          seq: 0,
          hotquestion_text: 'Mengapa penjual menolak ajuan pembatalan saya',
          shortcut_text: 'Toko TolakPembatalan',
          query_callback: {
            intent_id: 443,
            order_id: 0,
            node_id: '',
            shortcut_id: 0,
            question_id: 0,
            session_id: '429069262940170752',
            is_category: false,
            source: 1,
          },
        },
        {
          intent_id: 495,
          intent_name: '',
          faq_name: '',
          category_name: '',
          intent_type: 0,
          category_id: 0,
          icon_url: '',
          page_num: 0,
          seq: 0,
          hotquestion_text: 'Bagaimana cara mengaktifkan SPayLater?',
          shortcut_text: 'Aktivasi SPayLater',
          query_callback: {
            intent_id: 495,
            order_id: 0,
            node_id: '',
            shortcut_id: 0,
            question_id: 0,
            session_id: '429069262940170752',
            is_category: false,
            source: 1,
          },
        },
        {
          intent_id: 501,
          intent_name: '',
          faq_name: '',
          category_name: '',
          intent_type: 0,
          category_id: 0,
          icon_url: '',
          page_num: 0,
          seq: 0,
          hotquestion_text: 'Mengapa akun saya dibatasi?',
          shortcut_text: 'Akun Saya Dibatasi',
          query_callback: {
            intent_id: 501,
            order_id: 0,
            node_id: '',
            shortcut_id: 0,
            question_id: 0,
            session_id: '429069262940170752',
            is_category: false,
            source: 1,
          },
        },
        {
          intent_id: 448,
          intent_name: '',
          faq_name: '',
          category_name: '',
          intent_type: 0,
          category_id: 0,
          icon_url: '',
          page_num: 0,
          seq: 0,
          hotquestion_text: 'Mengapa penjual menolak ajuan pembatalan saya',
          shortcut_text: 'Toko TolakPembatalan',
          query_callback: {
            intent_id: 443,
            order_id: 0,
            node_id: '',
            shortcut_id: 0,
            question_id: 0,
            session_id: '429069262940170752',
            is_category: false,
            source: 1,
          },
        },
        {
          intent_id: 496,
          intent_name: '',
          faq_name: '',
          category_name: '',
          intent_type: 0,
          category_id: 0,
          icon_url: '',
          page_num: 0,
          seq: 0,
          hotquestion_text: 'Bagaimana cara mengaktifkan SPayLater?',
          shortcut_text: 'Aktivasi SPayLater',
          query_callback: {
            intent_id: 495,
            order_id: 0,
            node_id: '',
            shortcut_id: 0,
            question_id: 0,
            session_id: '429069262940170752',
            is_category: false,
            source: 1,
          },
        },
        {
          intent_id: 502,
          intent_name: '',
          faq_name: '',
          category_name: '',
          intent_type: 0,
          category_id: 0,
          icon_url: '',
          page_num: 0,
          seq: 0,
          hotquestion_text: 'Mengapa akun saya dibatasi?',
          shortcut_text: 'Akun Saya Dibatasi',
          query_callback: {
            intent_id: 501,
            order_id: 0,
            node_id: '',
            shortcut_id: 0,
            question_id: 0,
            session_id: '429069262940170752',
            is_category: false,
            source: 1,
          },
        },
        {
          intent_id: 449,
          intent_name: '',
          faq_name: '',
          category_name: '',
          intent_type: 0,
          category_id: 0,
          icon_url: '',
          page_num: 0,
          seq: 0,
          hotquestion_text: 'Mengapa penjual menolak ajuan pembatalan saya',
          shortcut_text: 'Toko TolakPembatalan',
          query_callback: {
            intent_id: 443,
            order_id: 0,
            node_id: '',
            shortcut_id: 0,
            question_id: 0,
            session_id: '429069262940170752',
            is_category: false,
            source: 1,
          },
        },
        {
          intent_id: 497,
          intent_name: '',
          faq_name: '',
          category_name: '',
          intent_type: 0,
          category_id: 0,
          icon_url: '',
          page_num: 0,
          seq: 0,
          hotquestion_text: 'Bagaimana cara mengaktifkan SPayLater?',
          shortcut_text: 'Aktivasi SPayLater',
          query_callback: {
            intent_id: 495,
            order_id: 0,
            node_id: '',
            shortcut_id: 0,
            question_id: 0,
            session_id: '429069262940170752',
            is_category: false,
            source: 1,
          },
        },
        {
          intent_id: 503,
          intent_name: '',
          faq_name: '',
          category_name: '',
          intent_type: 0,
          category_id: 0,
          icon_url: '',
          page_num: 0,
          seq: 0,
          hotquestion_text: 'Mengapa akun saya dibatasi?',
          shortcut_text: 'Akun Saya Dibatasi',
          query_callback: {
            intent_id: 501,
            order_id: 0,
            node_id: '',
            shortcut_id: 0,
            question_id: 0,
            session_id: '429069262940170752',
            is_category: false,
            source: 1,
          },
        },
      ],
    },
  };
}

export function HotQuestionCategory() {
  return {
    reply_type: 22,
    message: {
      message_id: '429069263888083457',
      text_key: '',
      text_value: 'sha',
    },
    message_extra: {
      categories: [
        {
          category_id: 21,
          category_name: 'Shopee Payment',
          icon_url: 'account_fraud',
          is_adoc_category: false,
        },
        {
          category_id: 22,
          category_name: 'Logistics',
          icon_url: 'bd',
          is_adoc_category: false,
        },
        {
          category_id: 24,
          category_name: 'Account & Fraud',
          icon_url: 'content_legal',
          is_adoc_category: false,
        },
        {
          category_id: 25,
          category_name: 'Return/Refund',
          icon_url: 'digital_product',
          is_adoc_category: false,
        },
        {
          category_id: 26,
          category_name: 'Return/Refund',
          icon_url: 'general',
          is_adoc_category: false,
        },
        {
          category_id: 27,
          category_name: 'Return/Refund',
          icon_url: 'logistics',
          is_adoc_category: false,
        },
        {
          category_id: 28,
          category_name: 'Return/Refund',
          icon_url: 'marketing',
          is_adoc_category: false,
        },
        {
          category_id: 29,
          category_name: 'Return/Refund',
          icon_url: 'others',
          is_adoc_category: false,
        },
        {
          category_id: 30,
          category_name: 'Return/Refund',
          icon_url: 'return_refund',
          is_adoc_category: false,
        },
        {
          category_id: 31,
          category_name: 'Return/Refund',
          icon_url: 'shopee_payment',
          is_adoc_category: false,
        },
        {
          category_id: 32,
          category_name: 'Return/Refund',
          icon_url: 'shopeepay',
          is_adoc_category: false,
        },
        {
          category_id: 33,
          category_name: 'Return/Refund',
          icon_url: 'spaylater',
          is_adoc_category: false,
        },
      ],
    },
  };
}

export function NewHotQuestion() {
  return {
    reply_type: 23,
    message: {
      message_id: '429069263888083457',
      text_key: '',
      text_value: 'sha',
    },
    message_extra: {
      cat_intent_list: {
        category_id: 0,
        category_name: '123',
        icon_url: '',
        intents: [
          {
            intent_id: 443,
            intent_name: '',
            faq_name: '',
            category_name: '',
            intent_type: 0,
            category_id: 0,
            icon_url: '',
            page_num: 0,
            seq: 0,
            hotquestion_text: 'Mengapa penjual menolak ajuan pembatalan saya',
            shortcut_text: 'Toko TolakPembatalan',
            query_callback: {
              intent_id: 443,
              order_id: 0,
              node_id: '',
              shortcut_id: 0,
              question_id: 0,
              session_id: '429069262940170752',
              is_category: false,
              source: 1,
            },
          },
          {
            intent_id: 495,
            intent_name: '',
            faq_name: '',
            category_name: '',
            intent_type: 0,
            category_id: 0,
            icon_url: '',
            page_num: 0,
            seq: 0,
            hotquestion_text: 'Bagaimana cara mengaktifkan SPayLater?',
            shortcut_text: 'Aktivasi SPayLater',
            query_callback: {
              intent_id: 495,
              order_id: 0,
              node_id: '',
              shortcut_id: 0,
              question_id: 0,
              session_id: '429069262940170752',
              is_category: false,
              source: 1,
            },
          },
          {
            intent_id: 501,
            intent_name: '',
            faq_name: '',
            category_name: '',
            intent_type: 0,
            category_id: 0,
            icon_url: '',
            page_num: 0,
            seq: 0,
            hotquestion_text: 'Mengapa akun saya dibatasi?',
            shortcut_text: 'Akun Saya Dibatasi',
            query_callback: {
              intent_id: 501,
              order_id: 0,
              node_id: '',
              shortcut_id: 0,
              question_id: 0,
              session_id: '429069262940170752',
              is_category: false,
              source: 1,
            },
          },
        ],
      },
    },
  };
}

export function OrderCard() {
  return {
    reply_type: 24,
    message: {
      message_id: '429069263888083457',
      text_key: '',
      text_value: 'Order card',
    },
    message_extra: {
      order: {
        order_id: 57730473258785,
        order_sn: '201030N89SJQS1',
        shop_id: 175379978,
        checkout_id: 57730473205374,
        uri_key: 'order_detail_page',
        title: 'test 2019-12-12 22:51:34.130',
        image: 'ad29861369c78bad67edff573c31e5da',
        price: 1000,
        specification: 'test 2019-12-12 22:51:34.130',
      },
    },
  };
}

export function OrderCardWithHQ() {
  return {
    reply_type: 16,
    message: {
      message_id: '42906926388808345745',
      text_key: '',
      text_value: 'Order',
    },
    message_extra: {
      specific_hot_questions: {
        order: {
          order_id: 57730473258785,
          shop_id: 175379978,
          checkout_id: 57730473205374,
          uri_key: 'order_detail_page',
          title: 'test adhasdh oais daiosd haoisd aosd asoidh aoisdh aosd h',
          image: 'ad29861369c78bad67edff573c31e5da',
          price: 1000,
          specification: 'test 2019-12-12 22:51:34.130',
          tracing_number: '88888888888888888888888888888888881234568888888888888888',
          delivered_by: 'sagdashdajd',
        },
        intent_hot_questions: [
          {
            intent_id: 443,
            intent_name: '',
            faq_name: '',
            category_name: '',
            intent_type: 0,
            category_id: 0,
            icon_url: '',
            page_num: 0,
            seq: 0,
            hotquestion_text: 'Mengapa penjual menolak ajuan pembatalan saya',
            shortcut_text: 'Toko TolakPembatalan',
            query_callback: {
              intent_id: 444,
              order_id: 0,
              node_id: '',
              shortcut_id: 0,
              question_id: 0,
              session_id: '429069262940170752',
              is_category: false,
              source: 1,
            },
          },
          {
            intent_id: 496,
            intent_name: '',
            faq_name: '',
            category_name: '',
            intent_type: 0,
            category_id: 0,
            icon_url: '',
            page_num: 0,
            seq: 0,
            hotquestion_text: 'Bagaimana cara mengaktifkan SPayLater?',
            shortcut_text: 'Aktivasi SPayLater',
            query_callback: {
              intent_id: 497,
              order_id: 0,
              node_id: '',
              shortcut_id: 0,
              question_id: 0,
              session_id: '429069262940170752',
              is_category: false,
              source: 1,
            },
          },
          {
            intent_id: 504,
            intent_name: '',
            faq_name: '',
            category_name: '',
            intent_type: 0,
            category_id: 0,
            icon_url: '',
            page_num: 0,
            seq: 0,
            hotquestion_text: 'Mengapa akun saya dibatasi?',
            shortcut_text: 'Akun Saya Dibatasi',
            query_callback: {
              intent_id: 505,
              order_id: 0,
              node_id: '',
              shortcut_id: 0,
              question_id: 0,
              session_id: '429069262940170752',
              is_category: false,
              source: 1,
            },
          },
          {
            intent_id: 506,
            intent_name: '',
            faq_name: '',
            category_name: '',
            intent_type: 0,
            category_id: 0,
            icon_url: '',
            page_num: 0,
            seq: 0,
            hotquestion_text: 'Mengapa akun saya dibatasias asd ad asd?',
            shortcut_text: 'Akun Saya Dibatasi asd as d',
            query_callback: {
              intent_id: 507,
              order_id: 0,
              node_id: '',
              shortcut_id: 0,
              question_id: 0,
              session_id: '429069262940170752',
              is_category: false,
              source: 1,
            },
          },
        ],
      },
    },
  };
}

export function OrderCardWithHQOrderDetail() {
  return {
    reply_type: 16,
    message: {
      message_id: '42906926388808345745',
      text_key: '',
      text_value: 'Order',
    },
    message_extra: {
      specific_hot_questions: {
        order: {
          order_id: 57730473258785,
          shop_id: 175379978,
          checkout_id: 57730473205374,
          uri_key: 'order_detail_page',
          title: 'test adhasdh oais daiosd haoisd aosd asoidh aoisdh aosd h',
          image: 'ad29861369c78bad67edff573c31e5da',
          price: 1000,
          total_price: 2000,
          specification: 'test 2019-12-12 22:51:34.130',
          tracing_number: '88888888888888888888888888888888881234568888888888888888',
          order_status_desc: 'completed',
          delivered_by: 'sagdashdajd',
          delivery_time_str: 'deelivery_time',
          expected_receive_time_str: 'expected_receive_time',
          ship_by_date_str: 'ship_by_date',
        },
        order_style: 'order_detail',
        intent_hot_questions: [
          {
            intent_id: 443,
            intent_name: '',
            faq_name: '',
            category_name: '',
            intent_type: 0,
            category_id: 0,
            icon_url: '',
            page_num: 0,
            seq: 0,
            hotquestion_text: 'Mengapa penjual menolak ajuan pembatalan saya',
            shortcut_text: 'Toko TolakPembatalan',
            query_callback: {
              intent_id: 444,
              order_id: 0,
              node_id: '',
              shortcut_id: 0,
              question_id: 0,
              session_id: '429069262940170752',
              is_category: false,
              source: 1,
            },
          },
          {
            intent_id: 496,
            intent_name: '',
            faq_name: '',
            category_name: '',
            intent_type: 0,
            category_id: 0,
            icon_url: '',
            page_num: 0,
            seq: 0,
            hotquestion_text: 'Bagaimana cara mengaktifkan SPayLater?',
            shortcut_text: 'Aktivasi SPayLater',
            query_callback: {
              intent_id: 497,
              order_id: 0,
              node_id: '',
              shortcut_id: 0,
              question_id: 0,
              session_id: '429069262940170752',
              is_category: false,
              source: 1,
            },
          },
          {
            intent_id: 504,
            intent_name: '',
            faq_name: '',
            category_name: '',
            intent_type: 0,
            category_id: 0,
            icon_url: '',
            page_num: 0,
            seq: 0,
            hotquestion_text: 'Mengapa akun saya dibatasi?',
            shortcut_text: 'Akun Saya Dibatasi',
            query_callback: {
              intent_id: 505,
              order_id: 0,
              node_id: '',
              shortcut_id: 0,
              question_id: 0,
              session_id: '429069262940170752',
              is_category: false,
              source: 1,
            },
          },
          {
            intent_id: 506,
            intent_name: '',
            faq_name: '',
            category_name: '',
            intent_type: 0,
            category_id: 0,
            icon_url: '',
            page_num: 0,
            seq: 0,
            hotquestion_text: 'Mengapa akun saya dibatasias asd ad asd?',
            shortcut_text: 'Akun Saya Dibatasi asd as d',
            query_callback: {
              intent_id: 507,
              order_id: 0,
              node_id: '',
              shortcut_id: 0,
              question_id: 0,
              session_id: '429069262940170752',
              is_category: false,
              source: 1,
            },
          },
        ],
      },
    },
  };
}

export function SPLater() {
  return {
    reply_type: 25,
    message: {
      message_id: getRandomNumbers(),
      text_key: '',
      text_value: 'Which of the following woud you like to enquire on?',
    },
    message_extra: {
      list_display_option: {
        display_num: 3,
        show_more_button: {
          text_key: '',
          text_value: 'Check out more',
          button_id: 'general_list_btn1',
          button_type: 'btn_check_out_more',
        },
        full_list_header_text: {
          text_key: '',
          text_value: 'Choose Issue',
        },
        full_list_confirm_button: {
          text_key: '',
          text_value: 'Confirm',
          button_id: 'general_list_btn2',
          button_type: 'btn_confirm',
        },
      },
      list_items: [
        {
          item_type: 'button_for_taskbot',
          button_for_taskbot: {
            node_id: 'SOP_7_NODE_B2',
            text_key: 'sop_7_node_0_8_msg_2',
            text_value: 'How to increase my SPayLater credit limit',
            button_id: 'btn_1',
            button_type: 'btn_taskbot',
          },
        },
        {
          item_type: 'button_for_taskbot',
          button_for_taskbot: {
            node_id: 'SOP_7_NODE_B21',
            text_key: 'sop_7_node_0_8_msg_3',
            text_value: 'How is late payment interest rate calculated',
            button_id: 'btn_2',
            button_type: 'btn_taskbot',
          },
        },
        {
          item_type: 'button_for_taskbot',
          button_for_taskbot: {
            node_id: 'SOP_7_NODE_B3',
            text_key: 'sop_7_node_0_8_msg_4',
            text_value: 'Why SPayLater credit did not increase by the same amount as what I paid',
            button_id: 'btn_3',
            button_type: 'btn_taskbot',
          },
        },
        {
          item_type: 'button_for_taskbot',
          button_for_taskbot: {
            node_id: 'SOP_7_NODE_B4',
            text_key: 'sop_7_node_0_8_msg_5',
            text_value: 'How to check or read my SPayLater bills?',
            button_id: 'btn_4',
            button_type: 'btn_taskbot',
          },
        },
        {
          item_type: 'button_for_taskbot',
          button_for_taskbot: {
            node_id: 'SOP_7_NODE_B5',
            text_key: 'sop_7_node_0_8_msg_6',
            text_value: 'Can I change my billing date?',
            button_id: 'btn_5',
            button_type: 'btn_taskbot',
          },
        },
      ],
    },
  };
}

export function Announcement() {
  return {
    reply_type: 18,
    message: {
      message_id: 99999,
      text_key: '',
      text_value: 'Please click the button below to change your phone number',
    },
    message_extra: {
      announcements: [
        {
          id: 1001,
          title: 'google',
          message: 'message',
          redirection_link: 'https://google.com',
        },
        {
          id: 1002,
          title: 'baidu',
          message: 'message',
          redirection_link: 'https://baidu.com',
        },
      ],
    },
  };
}

export function MySupportCase() {
  return {
    reply_type: 26,
    message: {
      message_id: '429069263888083459',
      text_key: '',
      text_value: 'My Support Case',
    },
    message_extra: {
      support_case_display: {
        support_case: {
          total_count: 3,
          update_count: 123,
        },
        url: 'https://google.com',
      },
    },
  };
}

export function IMAGE(imgUrl: string) {
  return {
    reply_type: 29,
    message: '',
    message_extra: { image_url: imgUrl },
  };
}

export function PODIMAGE(imgUrl: string) {
  return {
    reply_type: 32,
    message: '',
    message_extra: { image_url: imgUrl },
  };
}

export function IntentSelector() {
  return {
    reply_type: 28,
    message: {
      message_id: getRandomNumbers(),
      text_key: '',
      text_value: 'Which issues do you want to enquire on?',
    },
    message_extra: {
      is_intent_list: [
        {
          id: 1,
          intent_text: 'intent1',
          button_type: 'btn_taskbot',
          sub_intent_list: [
            {
              id: 1,
              sub_intent_text: 'hahaha1',
              sub_intent_node_point_id: 'SOP_1_NODE_D2_IS',
              answer_type: 0,
              button_id: 'btn_0_0',
              button: {
                button_type: 'btn_callback',
                node_id: 'SOP_1_NODE_0_2_1_5',
                text_key: '',
                text_value: '',
                url: '',
                uri_key: '',
                queue_name: '',
                extra_param: {
                  skeleton_node_point_id: 'SOP_1_NODE_C13',
                  session_id: '513859589649795840',
                  intent_id: 1,
                  sub_intent_node_point_id: 'SOP_1_NODE_D2_IS',
                },
                article_number: '',
                should_disappear: false,
                order_extra: null,
                style: 0,
                callback: {
                  should_disappear: false,
                  dialogue_id: '513859758260816640',
                  session_id: '513859589649795840',
                  input_type: 1,
                  message_text: '',
                  message_extra: {
                    node_id: 'SOP_1_NODE_0_2_1_5',
                    params: { order_id: 0, formstack_id: '' },
                  },
                },
                btn_modal_callback: null,
                button_id: '',
                is_seller: false,
              },
            },
          ],
          button_id: 'btn_0',
        },
        {
          id: 2,
          intent_text: 'labore i',
          button_type: 'btn_taskbot',
          sub_intent_list: [
            {
              id: 1,
              sub_intent_text: 'hahaha2',
              sub_intent_node_point_id: 'SOP_1_NODE_D5_IS',
              answer_type: 0,
              button_id: 'btn_1_0',
              button: {
                button_type: 'btn_callback',
                node_id: 'SOP_1_NODE_0_2_1_5',
                text_key: '',
                text_value: '',
                url: '',
                uri_key: '',
                queue_name: '',
                extra_param: {
                  skeleton_node_point_id: 'SOP_1_NODE_C13',
                  session_id: '513859589649795840',
                  intent_id: 2,
                  sub_intent_node_point_id: 'SOP_1_NODE_D5_IS',
                },
                article_number: '',
                should_disappear: false,
                order_extra: null,
                style: 0,
                callback: {
                  should_disappear: false,
                  dialogue_id: '513859758260816640',
                  session_id: '513859589649795840',
                  input_type: 1,
                  message_text: '',
                  message_extra: {
                    node_id: 'SOP_1_NODE_0_2_1_5',
                    params: { order_id: 0, formstack_id: '' },
                  },
                },
                btn_modal_callback: null,
                button_id: '',
                is_seller: false,
              },
            },
          ],
          button_id: 'btn_1',
        },
        {
          id: 3,
          intent_text: 'intent2',
          button_type: 'btn_taskbot',
          sub_intent_list: [
            {
              id: 1,
              sub_intent_text: '1',
              sub_intent_node_point_id: 'SOP_1_NODE_D3_IS',
              answer_type: 0,
              button_id: 'btn_2_0',
              button: {
                button_type: 'btn_callback',
                node_id: 'SOP_1_NODE_0_2_1_5',
                text_key: '',
                text_value: '',
                url: '',
                uri_key: '',
                queue_name: '',
                extra_param: {
                  skeleton_node_point_id: 'SOP_1_NODE_C13',
                  session_id: '513859589649795840',
                  intent_id: 3,
                  sub_intent_node_point_id: 'SOP_1_NODE_D3_IS',
                },
                article_number: '',
                should_disappear: false,
                order_extra: null,
                style: 0,
                callback: {
                  should_disappear: false,
                  dialogue_id: '513859758260816640',
                  session_id: '513859589649795840',
                  input_type: 1,
                  message_text: '',
                  message_extra: {
                    node_id: 'SOP_1_NODE_0_2_1_5',
                    params: { order_id: 0, formstack_id: '' },
                  },
                },
                btn_modal_callback: null,
                button_id: '',
                is_seller: false,
              },
            },
            {
              id: 2,
              sub_intent_text: '2',
              sub_intent_node_point_id: 'SOP_1_NODE_D4_IS',
              answer_type: 0,
              button_id: 'btn_2_1',
              button: {
                button_type: 'btn_callback',
                node_id: 'SOP_1_NODE_0_2_1_5',
                text_key: '',
                text_value: '',
                url: '',
                uri_key: '',
                queue_name: '',
                extra_param: {
                  skeleton_node_point_id: 'SOP_1_NODE_C13',
                  session_id: '513859589649795840',
                  intent_id: 3,
                  sub_intent_node_point_id: 'SOP_1_NODE_D4_IS',
                },
                article_number: '',
                should_disappear: false,
                order_extra: null,
                style: 0,
                callback: {
                  should_disappear: false,
                  dialogue_id: '513859758260816640',
                  session_id: '513859589649795840',
                  input_type: 1,
                  message_text: '',
                  message_extra: {
                    node_id: 'SOP_1_NODE_0_2_1_5',
                    params: { order_id: 0, formstack_id: '' },
                  },
                },
                btn_modal_callback: null,
                button_id: '',
                is_seller: false,
              },
            },
          ],
          button_id: 'btn_2',
        },
      ],
    },
  };
}

export function OrdinatorySelector() {
  return {
    reply_type: 10,
    message: {
      message_id: '534266004739423489',
      text_key: '',
      text_value: 'Accidentally selected "Order Received"? Don\'t worry, let us help:',
    },
    message_extra: {
      image_url: '',
      buttons_for_feedback: [
        {
          text_key: 'btn_feedback_3',
          text_value: 1,
          button_id: 'feedback_display_btn0',
          button_type: 'btn_feedback_display',
        },
        {
          text_key: 'btn_feedback_4',
          text_value: 2,
          button_id: 'feedback_display_btn1',
          button_type: 'btn_feedback_display',
        },
      ],
      buttons_for_general: [
        {
          button_type: 'btn_taskbot',
          node_id: 'SOP_1_NODE_0_1_1_8',
          text_key: '',
          // eslint-disable-next-line quotes
          text_value: "I haven't received my order",
          url: '',
          uri_key: '',
          queue_name: '',
          uri_extra: null,
          extra_param: null,
          article_number: '',
          should_disappear: false,
          order_extra: null,
          style: 10,
          callback: null,
          btn_modal_callback: null,
          button_id: 'btn_0',
          is_seller: false,
        },
        {
          button_type: 'btn_taskbot',
          node_id: 'SOP_1_NODE_0_1_1_9',
          text_key: '',
          text_value: 'I received damaged, incomplete, wrong or counterfeit items',
          url: '',
          uri_key: '',
          queue_name: '',
          uri_extra: null,
          extra_param: null,
          article_number: '',
          should_disappear: false,
          order_extra: null,
          style: 10,
          callback: null,
          btn_modal_callback: null,
          button_id: 'btn_1',
          is_seller: false,
        },
        {
          button_type: 'btn_taskbot',
          node_id: 'SOP_1_NODE_0_1_1_11',
          text_key: '',
          text_value: 'What is Shopee Guarantee?',
          url: '',
          uri_key: '',
          queue_name: '',
          uri_extra: null,
          extra_param: null,
          article_number: '',
          should_disappear: false,
          order_extra: null,
          style: 10,
          callback: null,
          btn_modal_callback: null,
          button_id: 'btn_0',
          is_seller: false,
        },
      ],
      feedback_options: null,
      hot_questions: null,
      specific_hot_questions: null,
      hit_feedback: false,
      head_intents: null,
      next_head_intents: null,
      categories: null,
      cat_intent_list: null,
      feedback_info: { feedback_result: 0, style: 2 },
      order: null,
      list_display_option: null,
      list_items: null,
      support_case_display: null,
      using_is_style: true,
    },
  };
}

export function ChatUI_message() {
  return {
    reply_type: 1001,
    message: '',
    message_extra: {
      thread_node_id: 'SOP_1_NODE_0_2_1_5',
      thread_id: '213231',
      thread_id_v2: '776064021726585998',
      round_id: '776064146708456576',
      task_flow_text: {
        // task_bot_info: {
        //   task_bot_id: 'SOP62',
        //   flow_id: '',
        //   editor_node_id: 'SOP62_Node22',
        //   node_id: 'SOP62_Node22.1',
        //   snapshot_id: '',
        // },
        is_bypass: false,
        is_end: false,
        case_id: '',
        has_feedback: false,
        content: 'fda',
        buttons: [
          {
            button_id: 'btn_2',
            button_style: 1, // 7
            button_text: 'driver_order_on_going_page', // click me
            action: {
              action_type: 1,
              is_bypass: false,
              url_info: {
                uri_key: 'driver_order_on_going_page',
                uri_extra: {
                  service_type: 1,
                  driver_deliviry_id: 'test',
                },
                extraParams: {},
              },
              task_bot_action: {
                current_task_bot_info: {
                  bot_id: 8,
                  case_id: 'case_1',
                  task_bot_id: 'SOP35',
                  flow_id: 'SOP35_F4',
                  editor_node_id: 'SOP35_F4_Node4',
                  node_id: 'SOP35_Node4.1',
                  tf_node_id: 'SOP35_Node4',
                  report_node_id: 'SOP35_F4_Node4.1',
                  node_name: 'Default',
                  snapshot_id: 'SOP35_F4_1656920854',
                },
                bot_id: 8,
                flow_id: 'SOP35_F4',
                snapshot_id: 'SOP35_F4_1656920854',
                next_task_bot_id: '',
                next_node_id: 'SOP35_Node6',
                simulation_id: 0,
                is_bypass: false,
              },
            },
            extra_param: {
              // guarantee_info: {
              //   article: {
              //     bot_id: 8,
              //     intent_id: 1222,
              //     title: 'Article Title',
              //     content: '\u003cp\u003eAnswer Content\u003c/p\u003e',
              //   },
              //   pop_up_content: {
              //     title: 'Extend Shopee Guarantee?',
              //     content: 'If you\'d like to give the seller more time, you can extend Shopee Guarantee to give the seller 0 extra days to ship your order and avoid order cancellation.',
              //     confirm_value: 'confirm',
              //     refuse_value: 'not now',
              //     read_more: 'Read More',
              //   },
              // },
            },
          },
          {
            button_id: 'btn_3',
            button_style: 1,
            button_text: 'driver_report_issue_page', // click me 2
            action: {
              action_type: 1, // 6
              url_info: {
                uri_key: 'driver_report_issue_page',
                uri_extra: {
                  service_type: 1,
                  order_id: '2',
                },
                extraParams: {},
              },
              is_bypass: false,
              task_bot_action: {
                current_task_bot_info: {
                  bot_id: 8,
                  case_id: 'case_1',
                  task_bot_id: 'SOP35',
                  flow_id: 'SOP35_F4',
                  editor_node_id: 'SOP35_F4_Node4',
                  node_id: 'SOP35_Node4.1',
                  tf_node_id: 'SOP35_Node4',
                  report_node_id: 'SOP35_F4_Node4.1',
                  node_name: 'Default',
                  snapshot_id: 'SOP35_F4_1656920854',
                },
                bot_id: 8,
                flow_id: 'SOP35_F4',
                snapshot_id: 'SOP35_F4_1656920854',
                next_task_bot_id: '',
                next_node_id: 'SOP35_Node7',
                simulation_id: 0,
                params: {
                  cancel_reason_code: {
                    key: 'cancel_reason_code',
                    data_type: 1,
                    variate_type: 2,
                    is_assigned: false,
                  },
                },
                is_bypass: false,
              },
            },
            // eslint-disable-next-line object-curly-newline
            extra_param: {
              // order_extra_info: {
              //   cancel_reasons: null,
              //   choose_cancel_reason: 'Choose Cancellation Reason',
              //   order_id: 0,
              //   pop_up_title_text: 'Request to cancel?',
              //   pop_up_text:
              //     'Your cancellation will be subject to the seller’s approval, as the order is currently being processed. Confirm your request to cancel this order?',
              //   refund_destination: '',
              //   pop_up_window_not_now: 'not now',
              //   pop_up_window_confirm: 'confirm',
              // },
            },
          },
        ],
      },
    },
  };
}

export function ChatUI_article() {
  return {
    reply_type: 1007,
    message: { message_id: '5' },
    message_extra: {
      is_feedback: true,
      task_flow_article: {
        task_bot_info: {},
        answer_info: {},
        article_number: '123',
        article_title: '[Akun Saya] Mengapa saya tidak bisa log in ke akun Shopee saya?',
        // content: '<div>我是内容</div>',
        bot_id: 1,
        intent_id: 31,
      },
    },
  };
}

export function TFE_OrderTipMsg() {
  return {
    reply_type: 1010,
    message: '',
    message_extra: {
      thread_node_id: 'SOP_1_NODE_0_2_1_5',
      thread_id: '213231',
      task_flow_click_text_reply: {
        task_bot_info: {
          task_bot_id: 'SOP62',
          flow_id: '',
          editor_node_id: 'SOP62_Node22',
          node_id: 'SOP62_Node22.1',
          snapshot_id: '',
        },
        is_bypass: false,
        is_end: false,
        case_id: '',
        has_feedback: false,
        content: 'If there is not specific to an order, please Click Here.',
        button: {
          button_id: 'button_1',
          button_style: 4,
          button_text: 'Click Here',
          action: {
            action_type: 2,
            is_bypass: false,
            task_bot_action: {
              current_task_bot_info: null,
              bot_id: 0,
              flow_id: '',
              snapshot_id: '',
              next_task_bot_id: 'SOP1',
              next_node_id: 'SOP1_v1_node1',
              simulation_id: 0,
              is_bypass: false,
            },
          },
        },
      },
    },
  };
}

export function initSessionV1() {
  return {
    code: 0,
    msg: 'success',
    data: {
      node_point_id: '',
      session_id: '630354617091937408',
      dialogue_id: '630354874269881472',
      dialogue_type: 'IDK',
      taskbot_id: '',
      taskbot_name: '',
      function: 'I Don\'t Know',
      is_dialogue_end: true,
      replies: [
        {
          reply_type: 6,
          message: {
            message_id: '630354874538316928',
            text_key: 'msg_dont_understand_2',
            text_value: '',
            is_rich_text: false,
          },
          message_extra: {
            using_is_style: false,
            image_url: '',
            buttons_for_live: [
              {
                text_key: '',
                text_value: 'Chat with agent',
                queue_name: '',
                uri_key: '',
                button_id: '',
                button_type: 'btn_live',
                extra_param: null,
                user_type_id: 0,
                enquiry_type_id: 0,
              },
            ],
            feedback_options: null,
            hot_questions: null,
            specific_hot_questions: null,
            hit_feedback: false,
            head_intents: null,
            next_head_intents: null,
            categories: null,
            cat_intent_list: null,
            order: null,
            list_display_option: null,
            list_items: null,
            support_case_display: null,
            grayscale_display_method: 0,
            has_announcement: false,
            label_clarification: null,
            live_agent_auto_queue_info: null,
          },
        },
      ],
    },
  };
}

export function initSessionV2() {
  return {
    code: 0,
    msg: 'success',
    data: {
      node_point_id: '',
      session_id: '630354586150777600',
      dialogue_id: '630354872361693952',
      dialogue_type: 'IDK',
      taskbot_id: '',
      taskbot_name: '',
      function: 'I Don\'t Know',
      is_dialogue_end: true,
      replies: [
        {
          reply_type: 6,
          message: {
            message_id: '630354872849023360',
            text_key: '',
            text_value: ' sorry, I don\'t understand what are you saying, would you like to talk to live agent?',
            is_rich_text: false,
          },
          message_extra: {
            using_is_style: false,
            image_url: '',
            buttons_for_live: [
              {
                text_key: '',
                text_value: 'Chat with agent',
                queue_name: '',
                uri_key: '',
                button_id: '',
                button_type: 'btn_live',
                extra_param: null,
                user_type_id: 0,
                enquiry_type_id: 0,
              },
            ],
            feedback_options: null,
            hot_questions: null,
            specific_hot_questions: null,
            hit_feedback: false,
            head_intents: null,
            next_head_intents: null,
            categories: null,
            cat_intent_list: null,
            order: null,
            list_display_option: null,
            list_items: null,
            support_case_display: null,
            grayscale_display_method: 0,
            has_announcement: false,
            thread_id: '',
            thread_node_id: '',
            thread_id_v2: '776064021726585998',
            round_id: '776064146708456576',
            is_bypass: false,
            task_flow_is_end: false,
            task_flow_text: null,
            task_flow_button_selector: null,
            task_flow_card: null,
            task_flow_related_intent: null,
            task_flow_popup: null,
            task_flow_option_selector: null,
            task_flow_article: null,
            label_clarification: null,
            simulator_mock: null,
            live_agent_auto_queue_info: null,
          },
        },
      ],
    },
  };
}

// order selection FAQ tip
export function OrderTipMsg(text?: any, data?: any, feedback?: any) {
  return {
    reply_type: 33,
    message: {
      message_id: getRandomNumbers(),
      text_key: '',
      text_value: text || 'Not specific to an order, ',
      text_extra: null,
    },
    message_extra: {
      buttons_for_taskbot: [
        {
          button_type: 'btn_live',
          button_id: 'btn_live',
          node_id: '',
          text_key: 'sop_2_node_0_2_1_btn_1',
          text_value: 'Click here',
        },
      ],
    },
    ...data,
  };
}

export function OrderSelectionFaq() {
  return {
    reply_type: 34,
    message: {
      message_id: getRandomNumbers(),
      text_key: '',
      text_value: 'Not specific to an order? Please select the question you have: ',
    },
    message_extra: {
      list_display_option: {
        display_num: 3,
        show_more_button: {
          text_key: '',
          text_value: 'Click for more',
          button_id: 'general_list_btn1',
          button_type: 'btn_check_out_more',
        },
        full_list_header_text: {
          text_key: '',
          text_value: 'Choose Issue',
        },
      },
      list_items: [
        {
          item_type: 'button_for_taskbot',
          button_for_taskbot: {
            node_id: 'SOP_7_NODE_B2',
            text_key: 'sop_7_node_0_8_msg_2',
            text_value: 'How to increase my SPayLater credit limit',
            button_id: 'btn_1',
            button_type: 'btn_taskbot',
          },
        },
        {
          item_type: 'button_for_taskbot',
          button_for_taskbot: {
            node_id: 'SOP_7_NODE_B21',
            text_key: 'sop_7_node_0_8_msg_3',
            text_value: 'How is late payment interest rate calculated',
            button_id: 'btn_2',
            button_type: 'btn_taskbot',
          },
        },
        {
          item_type: 'button_for_taskbot',
          button_for_taskbot: {
            node_id: 'SOP_7_NODE_B3',
            text_key: 'sop_7_node_0_8_msg_4',
            text_value: 'Why SPayLater credit did not increase by the same amount as what I paid',
            button_id: 'btn_3',
            button_type: 'btn_taskbot',
          },
        },
        {
          item_type: 'button_for_taskbot',
          button_for_taskbot: {
            node_id: 'SOP_7_NODE_B4',
            text_key: 'sop_7_node_0_8_msg_5',
            text_value: 'How to check or read my SPayLater bills?',
            button_id: 'btn_4',
            button_type: 'btn_taskbot',
          },
        },
        {
          item_type: 'button_for_taskbot',
          button_for_taskbot: {
            node_id: 'SOP_7_NODE_B5',
            text_key: 'sop_7_node_0_8_msg_6',
            text_value: 'Can I change my billing date?',
            button_id: 'btn_5',
            button_type: 'btn_taskbot',
          },
        },
      ],
    },
  };
}

export function RRHotQuestions() {
  return {
    reply_type: 35,
    message: {
      message_id: getRandomNumbers(),
      text_key: '',
      text_value: 'Not specific to an order? Please select the question you have: ',
    },
    message_extra: {
      specific_hot_questions: {
        intent_hot_questions: [
          {
            intent_id: 164,
            intent_name:
              ' the Referral Code not working / coins not credited after I shared it?',
            faq_name: '',
            category_name: '',
            intent_type: 1,
            intent_source: 1,
            category_id: 0,
            icon_url: '',
            page_num: 0,
            seq: 0,
            hotquestion_text:
              'is the Referral Code not working / coins not credited after I shared it?',
            shortcut_text: '',
            query_callback: {
              intent_id: 164,
              order_id: 0,
              node_id: '',
              shortcut_id: 0,
              question_id: 0,
              session_id: '766830458762471808',
              is_category: false,
              dialogue_id: '',
              source: 1,
              initial_intent: '',
            },
            callback_type: 0,
            is_live_agent: false,
            pass_through_data: null,
          },
        ],
        order: {
          return_items_count: 4,
          refund_amount: 21.0,
          total_price: 100,
          return_status: 2,
          order_status: 4,
          order_status_ext: 8,
          return_status_desc: 'Refund in Progress',
          order_status_desc: 'to ship',
          order_id: 83405602011875,
          order_sn: '210823BSQV72Q3',
          shop_id: 602226782,
          checkout_id: 83405602088718,
          uri_key: 'order_detail_page',
          title: 'hahahaha 2021-08-23 10:52:09.522 Aug 23 2021 16:13:14',
          image: 'e2353534fc51609e68fc2cf09838db2f',
          price: 1000,
          specification: 'color0,color1',
          button_type: '',
          button_id: '',
          tracing_number: 'SG213802312854CT',
          delivered_by: 'Standard Economy LPS',
        },
      },
    },
  };
}

export function OrderCardWithButton() {
  return {
    reply_type: 36,
    message: {},
    message_extra: {
      order: {
        return_items_count: 4,
        refund_amount: 21.0,
        total_price: 100,
        return_status: 2,
        order_status: 4,
        order_status_ext: 8,
        return_status_desc: 'Refund in Progress',
        order_status_desc: 'to ship',
        order_id: 83405602011875,
        order_sn: '210823BSQV72Q3',
        shop_id: 602226782,
        checkout_id: 83405602088718,
        uri_key: 'order_detail_page',
        title: 'hahahaha 2021-08-23 10:52:09.522 Aug 23 2021 16:13:14',
        image: 'e2353534fc51609e68fc2cf09838db2f',
        price: 1000,
        specification: 'color0,color1',
        button_type: '',
        button_id: '',
        tracing_number: 'SG213802312854CT',
        delivered_by: 'Standard Economy LPS',
      },
      buttons_for_general: [
        {
          button_type: 'btn_kb_intent',
          node_id: 'Check RR',
          text_key: '123',
          text_value: '234',
          kb_intent_id: 1,
          button_id: '',
          query_callback: {
            intent_id: 164,
            order_id: 0,
            node_id: '',
            shortcut_id: 0,
            question_id: 0,
            session_id: '787070878851530880',
            is_category: false,
            dialogue_id: '',
            source: 1,
            initial_intent: '',
          },
        },
      ],
    },
  };
}

export function FoodOrderCardWithButton() {
  return {
    'reply_type': 38,
    'message': {
      'message_id': '849961817426315140',
      'text_key': '',
      'text_value': '',
      'preview_message': '',
      'is_rich_text': false,
    },
    'message_extra': {
      'using_is_style': false,
      'image_url': '',
      'buttons_for_general': [{
        'button_type': 'btn_kb_intent',
        'node_id': '',
        'text_key': '',
        'text_value': 'weibin test on going',
        'url': '',
        'uri_key': '',
        'queue_name': '',
        'extra_param': null,
        'article_number': '',
        'kb_intent_id': 0,
        'should_disappear': false,
        'order_extra': null,
        'style': 0,
        'callback': null,
        'query_callback': {
          'intent_id': 10941,
          'order_id': 0,
          'node_id': '',
          'shortcut_id': 0,
          'question_id': 0,
          'session_id': '849961790263266944',
          'is_category': false,
          'dialogue_id': '',
          'source': 1,
          'driver_order_callback': {
            'driver_delivery_id': '1280301607130624189',
            'delivery_id': '1280301551883776439',
            'delivery_status': 'Accepted',
            'service_type': 1,
          },
          'initial_intent': '',
          'is_repeated_session': false,
          'repeated_session_type': '',
        },
        'btn_modal_callback': null,
        'button_id': 'btn_0',
        'is_seller': false,
        'node_point_id': '',
        'user_type_id': 0,
        'enquiry_type_id': 0,
      }, {
        'button_type': 'btn_kb_intent',
        'node_id': '',
        'text_key': '',
        'text_value': 'Informasi seputar pesanan Shopeefood yang sepi',
        'url': '',
        'uri_key': '',
        'queue_name': '',
        'extra_param': null,
        'article_number': '',
        'kb_intent_id': 0,
        'should_disappear': false,
        'order_extra': null,
        'style': 0,
        'callback': null,
        'query_callback': {
          'intent_id': 10905,
          'order_id': 0,
          'node_id': '',
          'shortcut_id': 0,
          'question_id': 0,
          'session_id': '849961790263266944',
          'is_category': false,
          'dialogue_id': '',
          'source': 1,
          'driver_order_callback': {
            'driver_delivery_id': '1280301607130624189',
            'delivery_id': '1280301551883776439',
            'delivery_status': 'Accepted',
            'service_type': 1,
          },
          'initial_intent': '',
          'is_repeated_session': false,
          'repeated_session_type': '',
        },
        'btn_modal_callback': null,
        'button_id': 'btn_0',
        'is_seller': false,
        'node_point_id': '',
        'user_type_id': 0,
        'enquiry_type_id': 0,
      }, {
        'button_type': 'btn_kb_intent',
        'node_id': '',
        'text_key': '',
        'text_value': 'Mengapa akun Mitra Pengemudi Shopee saya belum aktif?',
        'url': '',
        'uri_key': '',
        'queue_name': '',
        'extra_param': null,
        'article_number': '',
        'kb_intent_id': 0,
        'should_disappear': false,
        'order_extra': null,
        'style': 0,
        'callback': null,
        'query_callback': {
          'intent_id': 10904,
          'order_id': 0,
          'node_id': '',
          'shortcut_id': 0,
          'question_id': 0,
          'session_id': '849961790263266944',
          'is_category': false,
          'dialogue_id': '',
          'source': 1,
          'driver_order_callback': {
            'driver_delivery_id': '1280301607130624189',
            'delivery_id': '1280301551883776439',
            'delivery_status': 'Accepted',
            'service_type': 1,
          },
          'initial_intent': '',
          'is_repeated_session': false,
          'repeated_session_type': '',
        },
        'btn_modal_callback': null,
        'button_id': 'btn_0',
        'is_seller': false,
        'node_point_id': '',
        'user_type_id': 0,
        'enquiry_type_id': 0,
      }, {
        'button_type': 'btn_kb_intent',
        'node_id': '',
        'text_key': '',
        'text_value': 'Bagaimana proses pindah ke kota lain atau berhenti menjadi Mitra Pengemudi?',
        'url': '',
        'uri_key': '',
        'queue_name': '',
        'extra_param': null,
        'article_number': '',
        'kb_intent_id': 0,
        'should_disappear': false,
        'order_extra': null,
        'style': 0,
        'callback': null,
        'query_callback': {
          'intent_id': 10901,
          'order_id': 0,
          'node_id': '',
          'shortcut_id': 0,
          'question_id': 0,
          'session_id': '849961790263266944',
          'is_category': false,
          'dialogue_id': '',
          'source': 1,
          'driver_order_callback': {
            'driver_delivery_id': '1280301607130624189',
            'delivery_id': '1280301551883776439',
            'delivery_status': 'Accepted',
            'service_type': 1,
          },
          'initial_intent': '',
          'is_repeated_session': false,
          'repeated_session_type': '',
        },
        'btn_modal_callback': null,
        'button_id': 'btn_0',
        'is_seller': false,
        'node_point_id': '',
        'user_type_id': 0,
        'enquiry_type_id': 0,
      }],
      'feedback_options': null,
      'hot_questions': null,
      'specific_hot_questions': null,
      'hit_feedback': false,
      'head_intents': null,
      'next_head_intents': null,
      'next_shortcut_intents': null,
      'categories': null,
      'cat_intent_list': null,
      'order': null,
      'list_display_option': null,
      'list_items': null,
      'support_case_display': null,
      'grayscale_display_method': 0,
      'has_announcement': false,
      'thread_id': '',
      'thread_node_id': '',
      'thread_id_v2': '',
      'round_id': '',
      'is_bypass': false,
      'task_flow_is_end': false,
      'task_flow_text': null,
      'task_flow_button_selector': null,
      'task_flow_card': null,
      'task_flow_related_intent': null,
      'task_flow_popup': null,
      'task_flow_option_selector': null,
      'task_flow_article': null,
      'task_flow_click_text_reply': null,
      'task_flow_faq_list_reply': null,
      'task_flow_image': null,
      'clarification_stage': 0,
      'label_clarification': null,
      'simulator_mock': null,
      'live_agent_auto_queue_info': null,
      'live_agent_recommender_scenario': 0,
      'live_agent_queue_info': null,
      'case_tracker_item': null,
      'repeated_session_type': '',
      'probing_form': null,
      'shopee_food_driver_order_card': {
        'driver_delivery_id': '1280301607130624189',
        'delivery_id': '1280301551883776439',
        'order_id': '1280301378033152439',
        'shop_name': 'McDonalds463',
        'pickup_seq': 608,
        'delivery_status': 'Accepted',
        'create_time': 1668508205238,
        'receiver_name': 'hstestid10',
        'delivery_location': {
          'state': 'DKI JAKARTA',
          'city': 'KAB. KEPULAUAN SERIBU',
          'district': 'KEPULAUAN SERIBU SELATAN',
          'address': 'qa_buyer___-6.21,106.85',
        },
        'query_callback': {
          'driver_order_callback': {
            'driver_delivery_id': '1280301607130624189',
            'delivery_id': '1280301551883776439',
            'delivery_status': 'Accepted',
            'service_type': 1,
          },
        },
        'service_type': 1,
      },
      'button_for_click_here': null,
    },
  };
}

export function CaseTrackerImprovement() {
  return {
    reply_type: 37,
    message: {
      message_id: getRandomNumbers(),
      text_key: '',
      text_value: '',
    },
    message_extra: {
      buttons_for_general: [
        {
          button_type: 'btn_case_nudge',
          text_key: '',
          text_value: 'nudge the case',
          style: 1,
          url: '',
          uri_key: '',
          queue_name: '',
        },
        {
          button_type: 'btn_redirection',
          text_key: '',
          text_value: 'Provide information',
          uri_key: 'case_tracker_detail_page',
          uri_extra: { case_id: '1563047014162727011' },
          style: 1,
        },
        {
          button_type: 'btn_live',
          text_key: '',
          text_value: 'Connect me to an agent',
          url: '',
          uri_key: '',
          queue_name: '',
          style: 5,
        },
      ],
      // case_tracker_item: {
      //   id: 123,
      //   status: 1,
      //   title: 'Return / refund & Cancellation',
      //   order_sn: 'orderSN',
      //   order_pic_url: 'https://cf.shopee.sg/file/e6c7f3a67bbc44504aaff617ef372548',
      //   case_desc: "<div dir=\"ltr\">hello123</div><br><div class=\"gmail_quote\"><div dir=\"ltr\" class=\"gmail_attr\">csticketingsystem help test &lt;<a href=\"mailto:csticketingsystem.help.test.sg@mailgun.cs.shopee.com\">csticketingsystem.help.test.sg@mailgun.cs.shopee.com</a>&gt; 于2022年8月19日周五 11:22写道：<br></div><blockquote class=\"gmail_quote\" style=\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\"><u></u>\r\n\r\n\r\n  \r\n  \r\n  \r\n\r\n  \r\n\r\n  \r\n\r\n<div style=\"margin:0px;padding:12px 16px;background-color:rgb(255,255,255)\">\r\n  <table width=\"100%\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" bgcolor=\"#ffffff\">\r\n    <tbody><tr>\r\n      <td align=\"center\" valign=\"top\">\r\n        <img src=\"https://fileproxy.test.scsusercontent.com/api/v2/files/Y3MtaW5ob3VzZTAx/c3d2cbe838254ad98f81f20c872cb2fb.png\" alt=\"shopee\" width=\"110px\" height=\"35px\">\r\n      </td>\r\n    </tr>\r\n    <tr height=\"24px\"></tr>\r\n    \r\n    <tr>\r\n      <td align=\"left\" valign=\"top\" style=\"line-height:20px\">\r\n        Hi sellerjhtest111, \r\n        <div style=\"white-space:pre-wrap\"><p>wyd test mail</p></div>\r\n      </td>\r\n    </tr>\r\n    <tr height=\"24px\"></tr>\r\n    \r\n    <tr>\r\n      <td align=\"left\" valign=\"top\" style=\"line-height:20px\">\r\n        Your reference case number is <span style=\"color:rgb(235,68,40)\">1555459480156598292</span>. Please click on the button below on mobile phone to view the progress of your case.\r\n      </td>\r\n    </tr>\r\n    <tr height=\"24px\"></tr>\r\n    \r\n    <tr>\r\n      <td align=\"center\" valign=\"middle\" style=\"font-size:14px\">\r\n        <a href=\"https://cs.shopee.sg/universal-link/portal/mysupportcase/detail?caseid=1555459480156598292&amp;source=1&amp;deep_and_deferred=1\" style=\"color:rgb(255,255,255);display:inline-block;text-decoration:none;line-height:36px;background-color:rgb(235,68,40);width:43%;border-radius:2px\" target=\"_blank\">\r\n          View Case Status\r\n        </a>\r\n      </td>\r\n    </tr>\r\n    \r\n    <tr><td><table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"border-top:1px dashed rgb(181,181,181);margin-top:28px\">\r\n      <tbody><tr height=\"32px\"></tr>\r\n      <tr>\r\n        <td align=\"left\" valign=\"top\">\r\n          If your concern is urgent, please contact us via Live Chat or call us at our customer service hotline +65 6206 6610.\r\n        </td>\r\n      </tr>\r\n      <tr height=\"32px\"></tr>\r\n      <tr>\r\n        <td align=\"left\" valign=\"top\">While waiting for our response, you can also find useful information at out help center at:</td>\r\n      </tr>\r\n      <tr>\r\n        <td align=\"left\" valign=\"top\"><a href=\"https://help.shopee.sg\" target=\"_blank\">https://help.shopee.sg</a></td>\r\n      </tr>\r\n      <tr height=\"32px\"></tr>\r\n      <tr>\r\n        <td align=\"left\" valign=\"top\">Our Operation Hours:</td>\r\n      </tr>\r\n      <tr height=\"32px\"></tr>\r\n      <tr>\r\n        <td align=\"left\" valign=\"top\">Live Chat (Shopee App Help Centre):</td>\r\n      </tr>\r\n      <tr>\r\n        <td align=\"left\" valign=\"top\">Monday - Sunday (9:00 AM to 10:00 PM)</td>\r\n      </tr>\r\n      <tr height=\"32px\"></tr>\r\n      <tr>\r\n        <td align=\"left\" valign=\"top\">Call Hotline: +65 6206 6610,</td>\r\n      </tr>\r\n      <tr>\r\n        <td align=\"left\" valign=\"top\">Monday - Friday (9:00 AM to 6:00 PM)</td>\r\n      </tr>\r\n      <tr height=\"32px\"></tr>\r\n      <tr>\r\n        <td align=\"left\" valign=\"top\">Thank you for your patience and have a great day.</td>\r\n      </tr>\r\n      <tr height=\"32px\"></tr>\r\n      <tr>\r\n        <td align=\"left\" valign=\"top\">Best Regards,</td>\r\n      </tr>\r\n      <tr height=\"32px\"></tr>\r\n      <tr>\r\n        <td align=\"left\" valign=\"top\">Shopee Customer Service</td>\r\n      </tr>\r\n    </tbody></table>\r\n  </td></tr></tbody></table>\r\n</div>\r\n\r\n<br><br><p>ref:1560467087664906240:ref</p>\r\n</blockquote></div>\r\n",
      //   status_desc: 'Case In Progress',
      //   update_time: 1661156579
      // },
      case_tracker_item: {
        id: '1563047014162727011',
        status: 1,
        title: 'Return / refund & Cancellation',
        order_sn: 'orderSN',
        order_pic_url: 'https://cf.shopee.sg/file/e6c7f3a67bbc44504aaff617ef372548',
        status_desc: 'Case In Progress',
        update_time: 1661156579,
        form_schema: '{\"type\":\"object\",\"properties\":{\"userEmail\":{\"type\":\"string\",\"isDefault\":true,\"defaultTip\":\"This default field will be auto-filled with registered email for logged-in users. You can hide it, but cannot remove, map it to other case fields, or set it as not required.\",\"forceRequire\":true,\"fieldName\":\"email\",\"title\":\"Request Email\",\"required\":true,\"supportExistInShopee\":true,\"index\":0,\"sectionIndex\":0,\"verifyLogic\":\"{\\\"and\\\":[{\\\"and\\\":[{\\\"==\\\":[{\\\"!!\\\":{\\\"missing\\\":[\\\"userEmail\\\"]}},false]},{\\\"!=\\\":[{\\\"!!\\\":{\\\"var\\\":[\\\"userEmail\\\"]}},false]}]},{\\\"type\\\":[{\\\"var\\\":\\\"userEmail\\\"},\\\"RequestEmail\\\"]}]}\"},\"acf8694551\":{\"editable\":true,\"type\":\"string\",\"title\":\"Enquiry Type\",\"index\":1,\"sectionIndex\":0,\"options\":[{\"key\":\"acf8694551-1\",\"label\":\"option 1\"},{\"key\":\"acf8694551-2\",\"label\":\"option 2\"},{\"key\":\"acf8694551-3\",\"label\":\"option 3\"}],\"verifyLogic\":\"{\\\"if\\\":[false,{\\\"if\\\":[true,{\\\"and\\\":[{\\\"type\\\":[{\\\"var\\\":\\\"acf8694551\\\"},\\\"string\\\"]},{\\\"and\\\":[{\\\"==\\\":[{\\\"!!\\\":{\\\"missing\\\":[\\\"acf8694551\\\"]}},false]},{\\\"!=\\\":[{\\\"!!\\\":{\\\"var\\\":[\\\"acf8694551\\\"]}},false]}]}]},true]},{\\\"or\\\":[{\\\"and\\\":[{\\\"type\\\":[{\\\"var\\\":\\\"acf8694551\\\"},\\\"string\\\"]}]},{\\\"!\\\":[{\\\"and\\\":[{\\\"==\\\":[{\\\"!!\\\":{\\\"missing\\\":[\\\"acf8694551\\\"]}},false]},{\\\"!=\\\":[{\\\"!!\\\":{\\\"var\\\":[\\\"acf8694551\\\"]}},false]}]}]}]}]}\",\"supporting\":\"\",\"required\":false,\"valueFilterLogic\":{\"logics\":[null],\"checked\":false}},\"42cb052376\":{\"editable\":true,\"type\":\"string\",\"title\":\"File Upload\",\"index\":2,\"sectionIndex\":0,\"verifyLogic\":\"{\\\"if\\\":[false,{\\\"if\\\":[true,{\\\"and\\\":[{\\\"type\\\":[{\\\"var\\\":\\\"42cb052376\\\"},\\\"array\\\"]},{\\\"and\\\":[{\\\"==\\\":[{\\\"!!\\\":{\\\"missing\\\":[\\\"42cb052376\\\"]}},false]},{\\\"!=\\\":[{\\\"!!\\\":{\\\"var\\\":[\\\"42cb052376\\\"]}},false]}]}]},true]},{\\\"or\\\":[{\\\"and\\\":[{\\\"type\\\":[{\\\"var\\\":\\\"42cb052376\\\"},\\\"array\\\"]}]},{\\\"!\\\":[{\\\"and\\\":[{\\\"==\\\":[{\\\"!!\\\":{\\\"missing\\\":[\\\"42cb052376\\\"]}},false]},{\\\"!=\\\":[{\\\"!!\\\":{\\\"var\\\":[\\\"42cb052376\\\"]}},false]}]}]}]}]}\",\"supporting\":\"111\",\"required\":false,\"fileTypeAccepted\":[\".wav\",\".jpg\",\".jpeg\",\".pdf\",\".png\",\".doc\",\".docx\",\".xls\",\".xlsx\",\".txt\"],\"maxFileNum\":5,\"maxFileSize\":25},\"0d38469fd0\":{\"editable\":true,\"type\":\"string\",\"title\":\"Description Area\",\"index\":3,\"sectionIndex\":0}}}',
        submitted_data: '{\"42cb052376\":[],\"acf8694551\":\"option 1\",\"userEmail\":\"peter.wei0430@gmail.com\"}',
        ui_schema: '{\"userEmail\":{\"ui:widget\":\"RequestEmail\"},\"acf8694551\":{\"ui:edit\":false,\"ui:widget\":\"DropdownList\",\"ui:hidden\":false,\"ui:valueFilterLogic\":[]},\"42cb052376\":{\"ui:edit\":false,\"ui:widget\":\"FileUpload\"},\"0d38469fd0\":{\"ui:edit\":false,\"ui:widget\":\"DescriptionArea\"}}',
        enquiry_type: 'AirPay account hacked/ frozen/ banned',
        msg_type: 'Web',
      },
      uri_key: 'case_tracker_detail_page',
      uri_extra: { case_id: '1563047014162727011' },
    },
  };
}

export const OrderSelector = {
  'reply_type': 40,
  'message': {
    'message_id': '849961817426315141',
    'text_key': 'check_another_order_text',
    'text_value': 'To check on another order,please',
    'preview_message': '',
    'is_rich_text': false,
  },
  'message_extra': {
    'using_is_style': false,
    'image_url': '',
    'feedback_options': null,
    'hot_questions': null,
    'specific_hot_questions': null,
    'hit_feedback': false,
    'head_intents': null,
    'next_head_intents': null,
    'next_shortcut_intents': null,
    'categories': null,
    'cat_intent_list': null,
    'order': null,
    'list_display_option': null,
    'list_items': null,
    'support_case_display': null,
    'grayscale_display_method': 0,
    'has_announcement': false,
    'thread_id': '',
    'thread_node_id': '',
    'thread_id_v2': '',
    'round_id': '',
    'is_bypass': false,
    'task_flow_is_end': false,
    'task_flow_text': null,
    'task_flow_button_selector': null,
    'task_flow_card': null,
    'task_flow_related_intent': null,
    'task_flow_popup': null,
    'task_flow_option_selector': null,
    'task_flow_article': null,
    'task_flow_click_text_reply': null,
    'task_flow_faq_list_reply': null,
    'task_flow_image': null,
    'clarification_stage': 0,
    'label_clarification': null,
    'simulator_mock': null,
    'live_agent_auto_queue_info': null,
    'live_agent_recommender_scenario': 0,
    'live_agent_queue_info': null,
    'case_tracker_item': null,
    'repeated_session_type': '',
    'probing_form': null,
    'shopee_food_driver_order_card': null,
    'button_for_click_here': [{
      'text_key': 'click_here_text',
      'text_value': 'Click Here',
      'callback_params': {
        'driver_delivery_id': '1280301607130624189',
        'query_type': 2,
      },
      'order_type': 'food',
      'button_type': 'btn_select_order',
      'button_style': 1,
    }],
  },
};
